import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'adc-accordion',
  templateUrl: './adc-accordion.component.html',
  styleUrls: ['./adc-accordion.component.scss'],
  standalone: false
})
export class AdcAccordionComponent implements OnInit{
  show: number[] = [];
  @Input('data') data: any;
  @Input('type') type!: string;

  ngOnInit(): void {
    this.show.push(1);
    // this.show.push(2);
  }

  toggle(id: number) {
    if(this.show.includes(id)) {
      this.show =  this.show.filter((data: number) => data != id);
    } else {
      this.show.push(id);
    }
  }
}
